/**
 * Triggers a browser download for an in-memory JSON payload.
 *
 * Uses an object URL + transient anchor — the standard approach for
 * "save this object to a file" without a server round-trip. The anchor
 * is appended to the document so Firefox honours the click; the URL is
 * revoked after the click to release the blob from memory.
 */
export function downloadJson(filename: string, payload: unknown): void {
  if (typeof document === 'undefined' || typeof URL === 'undefined') return;
  const blob = new Blob([JSON.stringify(payload, null, 2)], {
    type: 'application/json',
  });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}
